import React from 'react';
import { Transition } from '@headlessui/react';
import { toast } from 'react-toastify';
import { fetchWithAuth } from '../utils/apiHelper';

const OperacionesList = ({ data = [], totales = {}, fetchData }) => {
  if (!Array.isArray(data)) {
    console.error("OperacionesList Error: data is not an array", data);
    return <p className="text-red-600">Error: Los datos no son válidos.</p>;
  }

  const handleDelete = async (id) => {
    try {
      await fetchWithAuth(`/operaciones/operaciones/${id}`, {
        method: 'DELETE',
      });
      toast.success('Registro eliminado exitosamente.');
      fetchData('operations');
    } catch (error) {
      console.error('Error eliminando el registro:', error);
      toast.error('Error al eliminar el registro.');
    }
  };

  return (
    <Transition
      show={data.length > 0}
      enter="transition-opacity duration-500"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-500"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="bg-white p-6 md:p-10 rounded-lg shadow-lg">
        <h3 className="text-2xl md:text-3xl font-bold mb-6 text-green-800">Operaciones</h3>
        <div className="overflow-x-auto mb-8">
          <table className="min-w-full bg-white border border-gray-300 rounded-lg shadow-sm">
            <thead className="bg-green-600 text-white">
              <tr>
                <th className="px-6 py-3 border-b text-left text-sm font-medium">Fecha</th>
                <th className="px-6 py-3 border-b text-left text-sm font-medium">Hora</th>
                <th className="px-6 py-3 border-b text-left text-sm font-medium">Tipo</th>
                <th className="px-6 py-3 border-b text-left text-sm font-medium">Descripción</th>
                <th className="px-6 py-3 border-b text-left text-sm font-medium">Costo</th>
                <th className="px-6 py-3 border-b text-left text-sm font-medium">Empleado</th>
                <th className="px-6 py-3 border-b text-left text-sm font-medium">Usuario</th>
                <th className="px-6 py-3 border-b text-left text-sm font-medium">Retirado</th>
                <th className="px-6 py-3 border-b text-left text-sm font-medium">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr
                  key={item.operacion_id}
                  className={`hover:bg-gray-100 transition-colors ${item.tipo === 'Retiro de efectivo' && item.retirado ? 'bg-red-200' : 'bg-green-100'}`}
                >
                  <td className="px-6 py-4 border-b font-semibold">{new Date(item.fecha).toLocaleDateString()}</td>
                  <td className="px-6 py-4 border-b font-semibold">{item.hora ? item.hora.slice(0, 5) : ''}</td>
                  <td className="px-6 py-4 border-b">{item.tipo}</td>
                  <td className="px-6 py-4 border-b">{item.comentario}</td>
                  <td className="px-6 py-4 border-b font-semibold">${item.costo.toLocaleString()}</td>
                  <td className="px-6 py-4 border-b font-semibold">{item.empleado_nombre}</td>
                  <td className="px-6 py-4 border-b font-semibold">{item.usuario_operacion}</td>
                  <td className={`px-6 py-4 border-b font-semibold ${item.tipo === 'Retiro de efectivo' ? (item.retirado ? 'text-red-600' : 'text-green-600') : ''}`}>
                    {item.tipo === 'Retiro de efectivo' ? (item.retirado ? 'Retirado' : 'No retirado') : '-'}
                  </td>
                  <td className="px-6 py-4 border-b">
                    <button
                      onClick={() => handleDelete(item.operacion_id)}
                      className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors"
                    >
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {Object.keys(totales).length > 0 && (
          <div className="bg-green-50 p-6 rounded-lg shadow-lg">
            <h3 className="text-2xl font-bold mb-4 text-green-800">Resumen de Totales</h3>
            <ul className="space-y-3">
              {Object.keys(totales).map((tipo) => (
                <li key={tipo} className="flex justify-between items-center">
                  <span className="text-lg font-semibold text-gray-700">{tipo}:</span>
                  <span className="text-lg font-semibold text-gray-900">${totales[tipo].toLocaleString()}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </Transition>
  );
};

export default OperacionesList;
